var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentConfig)?_c(_vm.componentConfig.component,_vm._b({tag:"component",model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'component',_vm.componentConfig.props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }